<mat-form-field appearance="outline" style="width: 100%">
  <mat-select [(value)]="standardPeriodId" (selectionChange)="emitPeriod($event)">
    <mat-optgroup *ngFor="let group of periodOptions" [label]="group.name">
      <mat-option *ngFor="let option of group.options" [value]="option.id">
        {{option.name}}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>
